import { Event } from '../../_base/eventBus/EventBus';

export class ClaimCommented implements Event {
    constructor(public claimId: number) {}
}
